export const VehicleStatus = {
  parked: 'Parked',
  running: 'Running',
  idling: 'Idling',
  notResponding: 'Not responding',
};
